export default __webpack_public_path__ + "static/media/game-score-fail-1.647cbc82.mp3";